(function () {
  const MODAL_KEY = 'localizationModalSeen';
  const SELECT_CONTAINER_SELECTOR = '.markets-select';
  const LOCALIZATION_WRAPPER_SELECTOR = '.desktop-localization-wrapper';
  const COUNTRY_BUTTON_SELECTOR = '.country-selector__button';
  const COUNTRY_LIST_SELECTOR = '.country-selector__list';
  const LANGUAGE_BUTTON_SELECTOR = '.language-country-selector__button';
  const LANGUAGE_LIST_SELECTOR = '.language-selector__list';
  const TOGGLE_CLASS = 'language-selector__button--open';
  const BACKGROUND_SELECTOR = '.desktop-localization--background';

  const modal = document.getElementById('localizationModal');
  const backgroundEl = document.querySelector(BACKGROUND_SELECTOR);

  // Éviter les requêtes DOM répétées
  const getBackground = () => backgroundEl;

  // État global
  const selectInstances = [];
  const dropdownInstances = [];

  // === Utilitaires ===

  function markModalAsSeen() {
    localStorage.setItem(MODAL_KEY, 'true');
    document.querySelector('.desktop-localization-wrapper')?.classList.remove('desktop-localization-wrapper--auto');
  }

  function hideAllSelects() {
    selectInstances.forEach(({ wrapper, container }) => {
      wrapper.hidden = true;
      container.classList.remove('is-open');
    });
    const bg = getBackground();
    if (bg) {
      bg.classList.add('tw-hidden');
      bg.classList.remove('!tw-block');
    }
  }

  function hideAllDropdowns() {
    dropdownInstances.forEach(({ button, list }) => {
      list.hidden = true;
      button.classList.remove(TOGGLE_CLASS);
    });
  }

  // === Gestion des dropdowns (pays / langues) ===

  function initMultipleToggles(buttonSelector, listSelector) {
    const buttons = document.querySelectorAll(buttonSelector);
    const lists = document.querySelectorAll(listSelector);

    if (buttons.length !== lists.length) return;

    buttons.forEach((button, index) => {
      const list = lists[index];
      if (!button || !list) return;

      dropdownInstances.push({ button, list });

      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const isHidden = list.hidden;

        hideAllDropdowns();

        if (isHidden) {
          if (window.cvBuildCountryList) window.cvBuildCountryList(list);
          list.hidden = false;
          button.classList.add(TOGGLE_CLASS);
        }
      });

      list.addEventListener('click', (e) => e.stopPropagation());
    });
  }

  // === Gestion des sélections (clic sur un lien) ===

  function addSelectionHandlers() {
    function setupLinkHandler(links, inputName, buttonSelector) {
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const value = link.textContent.trim();
          const buttonContent = link.closest('.disclosure__list-wrapper')?.querySelector(`${buttonSelector} .language-selector__button-content`);
          if (buttonContent) buttonContent.textContent = value;

          const hiddenInput = document.querySelector(`input[name="${inputName}"]`);
          if (hiddenInput && link.dataset.value) {
            hiddenInput.value = link.dataset.value;
          }

          hideAllDropdowns();
        });
      });
    }

    setupLinkHandler(
      document.querySelectorAll('.country--link'),
      'country_code',
      '.country-selector__button'
    );

    setupLinkHandler(
      document.querySelectorAll('.language--link'),
      'locale_code',
      '.language-country-selector__button'
    );
  }

  // === Gestion des modaux "markets-select" ===

  function onToggleClick(event, instance) {
    event.preventDefault();
    event.stopPropagation();

    const { container, wrapper } = instance;
    const isHidden = wrapper.hidden;

    hideAllSelects();

    if (isHidden) {
      container.classList.add('is-open');
      wrapper.hidden = false;
      wrapper.classList.remove('!tw-hidden');

      if (window.cvBuildCountryListsIn) window.cvBuildCountryListsIn(wrapper);

      wrapper.querySelectorAll('img[data-flag-src]').forEach((img) => {
        img.src = img.getAttribute('data-flag-src');
        img.removeAttribute('data-flag-src');
      });

      const bg = getBackground();
      if (bg) {
        bg.classList.remove('tw-hidden');
        bg.classList.add('!tw-block');
      }
    }
  }

  // === Gestion du clic global ===

  function onDocumentClick(event) {
    // Ne rien faire si le clic est dans un banner Shopify
    if (event.target.closest('.shopify-pc__banner__dialog')) return;

    let clickInsideSelect = false;
    let clickInsideDropdown = false;

    // Vérifier les selects
    for (const { handle, wrapper, container } of selectInstances) {
      if (wrapper.contains(event.target) || handle.contains(event.target)) {
        clickInsideSelect = true;
        break;
      }
    }

    if (!clickInsideSelect) {
      hideAllSelects();
      markModalAsSeen();
    }

    // Vérifier les dropdowns
    for (const { button, list } of dropdownInstances) {
      if (button.contains(event.target) || list.contains(event.target)) {
        clickInsideDropdown = true;
        break;
      }
    }

    if (!clickInsideDropdown) {
      hideAllDropdowns();
    }
  }

  // === Initialisation ===

  function init() {
    // Initialiser les "markets-select"
    document.querySelectorAll(SELECT_CONTAINER_SELECTOR).forEach(container => {
      const handle = container.querySelector('.markets-select__fake-select-handle');
      const wrapper = container.nextElementSibling;

      if (
        handle &&
        wrapper &&
        wrapper.matches(LOCALIZATION_WRAPPER_SELECTOR)
      ) {
        const instance = { handle, wrapper, container };
        selectInstances.push(instance);
        handle.addEventListener('click', (e) => onToggleClick(e, instance));
      }
    });

    // Éviter double binding
    if (!window.__localizationClickBound) {
      document.addEventListener('click', onDocumentClick);
      window.__localizationClickBound = true;
    }

    // Initialiser dropdowns
    initMultipleToggles(COUNTRY_BUTTON_SELECTOR, COUNTRY_LIST_SELECTOR);
    initMultipleToggles(LANGUAGE_BUTTON_SELECTOR, LANGUAGE_LIST_SELECTOR);

    // Ajouter gestionnaires de sélection
    addSelectionHandlers();
  }

  // Lancer l'init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
